import { Table } from '../../Table';
import useRankingTable from '../../../hooks/useRankingTable';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking (Five main instruments)',
    isStatic: false
  },
  sub_asset_type: {
    name: 'Sub-asset type code of the five main instruments in which the AIF is trading',
    isStatic: false
  },
  instrument_code_type: {
    name: 'Instrument code type of the five main instruments in which the AIF is trading',
    isStatic: false
  },
  instrument_name: {
    name: 'Instrument name of the five main instruments in which the AIF is trading',
    isStatic: false
  },
  isin: {
    name: 'Instrument ISIN code of the five main instruments in which the AIF is trading',
    isStatic: false
  },
  exchange_code: {
    name: 'AII exchange code',
    isStatic: false
  },
  product_code: {
    name: 'AII exchange product code',
    isStatic: false
  },
  derivative_type: {
    name: 'AII derivative type',
    isStatic: false
  },

  // instructions: {
  //   isStatic: true,
  //   name: 'Instructions',
  //   description:
  //     'Either an ISIN or an All code should be entered, but not both',
  // },

  // all: {
  //   isStatic: true,
  //   name: 'All',
  //   description: 'Fields below',
  // },

  put_call: {
    name: 'AII Put/Call identifier',
    isStatic: false
  },
  expiry_date: {
    name: 'AII expiry/delivery/prompt date',
    isStatic: false
  },
  strike_price: {
    name: 'AII strike price',
    isStatic: false
  },
  // other: {
  //   isStatic: true,
  //   name: 'Other',
  //   description: 'Fields below',
  // },
  position_type: {
    name: 'Position type of the five main instruments in which the AIF is trading',
    isStatic: false
  },
  position_value: {
    name: 'Instrument position value of the five main instruments in which the AIF is trading',
    isStatic: false
  },

  short_position_hedging_rate: {
    name: 'Short position hedging percentage *',
    isStatic: false
  }
};

export function MainInstruments({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { columns, onChange, tables } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.MAIN_INSTRUMENTS,
    onChangeFund,
    schema: schema.MAIN_INSTRUMENTS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MAIN_INSTRUMENTS?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'MAIN_INSTRUMENTS',
    order: 64
  });

  return (
    <StyledTables id="reporttables-main-instruments-group">
      {tables.map((rows, index) => (
        <div
          className={isMultiFunds && 'table-wrapper'}
          id={`reporttables-main-instruments-item-${index + 1}`}
          key={index + 'MAIN_INSTRUMENTS'}
        >
          <Table
            id={`reporttables-main-instruments-table-${index + 1}`}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyTopRows={isMultiFunds ? 1 : null}
          />
        </div>
      ))}
    </StyledTables>
  );
}
